import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, StarIcon } from 'lucide-react';
const buyers = [{
  name: 'Fernando D.',
  city: 'Mendoza'
}, {
  name: 'Gonzalo R.',
  city: 'San Juan'
}, {
  name: 'Sebastián M.',
  city: 'Catamarca'
}, {
  name: 'Hernán B.',
  city: 'Jujuy'
}, {
  name: 'Facundo L.',
  city: 'Salta'
}, {
  name: 'Martín T.',
  city: 'Neuquén'
}, {
  name: 'Nicolás P.',
  city: 'Santa Cruz'
}, {
  name: 'Ramiro V.',
  city: 'Chubut'
}, {
  name: 'Gabriel A.',
  city: 'La Rioja'
}, {
  name: 'Leandro S.',
  city: 'Córdoba'
}, {
  name: 'Emiliano K.',
  city: 'Río Negro'
}, {
  name: 'Ricardo H.',
  city: 'Tucumán'
}, {
  name: 'Luciana C.',
  city: 'San Luis'
}, {
  name: 'Andrea F.',
  city: 'Buenos Aires'
}, {
  name: 'Patricia G.',
  city: 'Mendoza'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextInterval);
    }, 5000);
  };
  return <AnimatePresence data-id="element-291">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-[#3E2723] rounded-xl shadow-2xl border border-[#5D4037] p-4 flex items-center gap-4" data-id="element-292">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-200" data-id="element-293">
            <XIcon className="w-4 h-4" data-id="element-294" />
          </button>

          <div className="w-12 h-12 bg-[#5D4037] rounded-full flex items-center justify-center flex-shrink-0" data-id="element-295">
            <StarIcon className="w-7 h-7 text-yellow-500 fill-yellow-400" data-id="element-296" />
          </div>

          <div data-id="element-297">
            <p className="text-sm text-white" data-id="element-298">
              <span className="font-bold" data-id="element-299">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs font-bold text-brand-orange mt-1 flex items-center gap-1" data-id="element-300">
              ⭐ Compra verificada
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-301">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}